'use strict'
//Pages
import Home from './pages/home'

//Components
import Events from './components/events'
import ForWhom from './components/for-whom'
import Faq from './components/faq'
import Header from './components/header'
import HighlightsSlider from './components/highlights-slider'
import Slider from './components/slider'
import SliderIconsFull from './components/slider-cards-icons-full'
import SliderIcons from './components/slider-cards-icons'
import Solutions from './components/solutions'
import StepByStep from './components/step-by-step'
import Timeline from './components/timeline'
import WhoTrusts from './components/who-trusts'
import Video from './components/video'
import News from './components/news'
import Locations from './components/locations'
import Testimonials from './components/testimonials'
import DescriptionSlider from './components/description-quote'
import CountSales from './components/countsales'
import TalkWithUs from './components/talkWithUs'
import SearchForm from './components/search'

export default class App {
  constructor() {
    // # Declare an Element for each class
    // -> Components
    const EventsElement = document.querySelector('.events')
    const FaqElement = document.querySelector('.faq')
    const ForWhomElement = document.querySelector('.for-whom')
    const HeaderElement = document.querySelector('.header-main')
    const HighlightsSliderElement = document.querySelector(
      '.highlights_slider_slider'
    )
    const TestimonialsElement = document.querySelector('.testimonials_slider')
    const SliderIconsFullElement = document.querySelector('.slider-icons-full')
    const SliderIconsElement = document.querySelector('.slider-icons')
    const SliderElement = document.querySelector('.slider_slider_component')
    const SolutionsElement = document.querySelector('.solutions')
    const StepByStepElement = document.querySelector('.step-by-step-slider')
    const TimelineElement = document.querySelector('.timeline')
    const WhoTrustsElement = document.querySelector('.who-trusts')
    const VideoElement = document.querySelector('.video')
    const NewsElement = document.querySelector('.news')
    const LocationsElement = document.querySelector('.locations_slider_wrap')
    const DescriptionSliderElement = document.querySelector(
      '.description_slider'
    )
    const ComponentCountSales = document.querySelector('.countsales')
    const ComponentSearchForm = document.querySelector('.form-page-search')
    const ComponentTalkWithUs = document.querySelector('.talk-with-us')

    // -> Pages
    const HomeElement = document.querySelector('.home')

    // # Test if Element exists to load corresponding classes
    // -> Components
    EventsElement ? new Events() : null
    ForWhomElement ? new ForWhom() : null
    FaqElement ? new Faq() : null
    HeaderElement ? new Header() : null
    HighlightsSliderElement ? new HighlightsSlider() : null
    TestimonialsElement ? new Testimonials() : null
    SliderElement ? new Slider() : null
    SliderIconsFullElement ? new SliderIconsFull() : null
    SliderIconsElement ? new SliderIcons() : null
    SolutionsElement ? new Solutions() : null
    StepByStepElement ? new StepByStep() : null
    TimelineElement ? new Timeline() : null
    WhoTrustsElement ? new WhoTrusts() : null
    VideoElement ? new Video() : null
    NewsElement ? new News() : null
    LocationsElement ? new Locations() : null
    DescriptionSliderElement ? new DescriptionSlider() : null
    ComponentCountSales ? new CountSales() : null
    ComponentSearchForm ? new SearchForm() : null
    //ComponentTalkWithUs ? new TalkWithUs() : null

    // -> Pages
    HomeElement ? new Home() : null
  }
}

// window.TalkWithUs = TalkWithUs;

new App()
